<template>
<div id="app">
  <section class="head">
    <div class="banner">
      <img :src="'head/head.png'|img-pc">
    </div>
    <img class="timeline" :src="'head/xiaohongshu.png'|img-pc">
  </section>
  <section class="billboard">

    <template v-if="progress.step=='shortlist'">
      <board class="brown" initState="shrink" :table="table.shortlist" type="shortlist" @generate="generate_pick" 
        tip="以上作品排名不分先后，通过海选的所有作品均为入围，入围作品将参与所有奖项决选。"></board>
      <board-card color="grey" type="excellent" :timer="timer[0]"></board-card>
      <board-card color="gold" type="final" :timer="timer[1]"></board-card>
    </template>
    <template v-if="progress.step=='excellent'">
      <board class="grey" :table="table.excellent" type="excellent" @generate="generate_pick"
        tip="以上作品排名不分先后，入围最终榜单决选的所有作品均为优秀奖，优秀作品将参与最终榜单决选。"></board>
      <board-card color="gold" type="final" :timer="timer[1]"></board-card>
      <board class="brown" :initState="global.pc?'shrink':'mini'" :table="table.shortlist" type="shortlist" @generate="generate_pick"
        tip="以上作品排名不分先后，通过海选的所有作品均为入围，入围作品将参与所有奖项决选。"></board>
    </template>
    <template v-if="progress.step=='final'">
    <!--
      <board v-if="showFinal" class="grey" :table="table.final" type="final" @generate="generate_pick" :judges="judges"></board>
      <board-card v-else color="gold" class="ff" type="final" :timer="timer[1]"></board-card>
      <board class="gold" initState="mini" :table="table.college" type="college" tip="以下排名不分先后，按校名首字母排序。"></board>
      <board class="gold" initState="mini" :table="table.teacher" type="teacher" tip="以下排名不分先后，按姓名首字母排序。"></board>
      <board class="gold" :table="table.organization" type="organization" tip="以下排名不分先后，按机构名首字母排序。"></board>
      <board class="gold" :table="table.industry" type="industry"></board>
      <board class="grey" :initState="global.pc?'shrink':'mini'" :table="table.excellent" type="excellent" @generate="generate_pick"
        tip="以上作品排名不分先后，入围最终榜单决选的所有作品均为优秀奖，优秀作品将参与最终榜单决选。"></board>
    -->
      <board class="grey" :initState="global.pc?'shrink':'mini'" :table="table.excellent" type="excellent" @generate="generate_pick"></board>
    </template>

    <van-popup v-model="picker.show" position="bottom">
      <van-picker title="作品名称" show-toolbar
        :columns="picker.items"
        value-key="works"
        @cancel="picker.show=false"
        @confirm="generate_confirm"
      />
    </van-popup>
    <van-popup v-model="award.show" class="award">
      <img :src="award.pic"/>
    </van-popup>
    <canvas ref="canvas" width="751" height="1332" style="display: none;"></canvas>
    <canvas ref="canvas-excellent" width="751" height="1332" style="display: none;"></canvas>
    <canvas ref="canvas-final" width="751" height="1332" style="display: none;"></canvas>
  </section>
<!--
  <div class="middle-banner">   
    <img :src="`head/middle-banner.png`|img-pc"/>
  </div>
-->
  <section class="judge">
    <img class="title" :src="'head/title-pingshenguwen.svg'|img">
    <div class="judges consult-row clear">   
      <div v-for="item in consult" >
        <img :src="`judge/judges_${item.key}.png`|img-pc">
        <h6>{{item.name}}</h6>
        <p v-html="item.desc"></p>
      </div>
    </div>
    <img class="title" :src="'head/title-judge-zhongwen.svg'|img">
    <div class="judges clear">   
      <div v-for="item in judges4zhongwen" >
        <img :src="`judge/judges_${item.key}.png`|img-pc">
        <h6 v-html="item.name"></h6>
        <p v-html="item.desc"></p>
      </div>
    </div>
    <img class="title" :src="'head/title-judge-duowenzhong.svg'|img">
    <div class="judges clear">   
      <div v-for="item in judges4duowenzhong" >
        <img :src="`judge/judges_${item.key}.png`|img-pc">
        <h6 v-html="item.name"></h6>
        <p v-html="item.desc"></p>
      </div>
    </div>
    <img class="title" :src="'head/title-saishiguwen.svg'|img">
    <div class="judges clear">   
      <div v-for="item in consult1" >
        <img :src="`judge/judges_${item.key}.png`|img-pc">
        <h6>{{item.name}}</h6>
        <p v-html="item.desc"></p>
      </div>
    </div>
  </section>

  <section class="logo-wall">
    <img :src="'logo-wall.png'|img-pc"/>
  </section>

  <section class="subscribe clear">
    <img class="logo" :src="'logo-hanyi.png'|img"/>
    <div>
      <h6>汉仪字库</h6>
      <p>关注官方订阅号：hanyifonts<br/>接收在线颁奖实时提醒</p>
    </div>
    <img class="qr" :src="'qr-hanyi.png'|img"/>
  </section>
<!--
  <div class="bottom clear" v-if="progress.step=='final'">
    <img :class="`txt ${bottom.txt}`" :src="`bottom/txt-${bottom.txt}.png`|img-pc"/>
    <a class="btn" href="//fontstar.com.cn/" target="_blank"><img :src="`bottom/btn.png`|img-pc"/></a>
  </div>
-->

</div>
</template>

<script>
import Board from './components/Board.vue';
import BoardCard from './components/BoardCard.vue';

export default {
  name: 'App',
  components: {
    Board,
    BoardCard,
  },
  data(){
    let 
      bottom = {
        timer: '',
        txt: 'award',
      },
      table = {
        shortlist: [],
        excellent: [],//require('@/assets/json/excellent.json'),
        final: [],//require('@/assets/json/final.json'),
        industry:[{'name': '黄珊珊、鲁剑', 'project':'《汉字守护计划》', 'recommender':''}],
        college: ['澳门科技大学', '北京服装学院', '北京航空航天大学', '北京理工大学', '北京联合大学', '大连工业大学',
          '大连民族大学', '大连艺术学院', '福州大学厦门工艺美术学院', '福州外语外贸学院', '广东工业大学', '广东文艺职业学院',
          '广西外国语学院', '广州美术学院', '贵阳信息科技学院', '合肥工业大学', '河北美术学院', '河北师范大学', '湖北大学',
          '湖北汽车工业学院', '湖南科技大学', '湖南师范大学美术学院', '吉林艺术学院', '江西泰豪动漫职业学院', '鲁迅美术学院',
          '南昌大学建筑与设计学院', '南华大学', '南京林业大学', '南京晓庄学院', '南宁理工学院', '宁波城市职业技术学院',
          '宁波大学', '宁波大学科学技术学院', '青岛农业大学', '厦门大学嘉庚学院', '山东工艺美术学院', '山东艺术学院',
          '山西应用科技学院', '陕西服装工程学院', '上海第二工业大学', '上海理工大学', '石河子大学', '四川大学',
          '四川国际标榜职业学院', '四川美术学院', '苏州大学应用技术学院', '天津科技大学', '天津美术学院', '武汉纺织大学外经贸学院',
          '武汉工程大学', '武汉工程科技学院', '西安美术学院', '燕京理工学院', '云南师范大学', '长春人文学院', '中国传媒大学', 
          '中国美术学院', '中山职业技术学院', '中央美术学院', '重庆科技学院'
        ],
        teacher: ['蔡飞', '曹文强', '陈华沙', '陈楠', '陈滢竹', '董红艳', '顾正友', '郭晓晔', '韩诚', '韩绪', '何宇', '侯天航', 
          '黄翎', '黄志雄', '季叶申', '蒋新', '孔祥国', '黎娜', '李瑾', '李婧', '李少波', '李贞', '刘洪涛', '刘维尚', '刘钊', '楼文青', 
          '陆赉', '毛碧莲', '邱启雄', '商毅', '石建航', '宋书寒', '孙红霞', '万千个', '王静艳', '王娟', '王绍强', '王祥', '王晓峰', '王颖', 
          '王泽闻', '肖静', '熊轩锐', '许钰伟', '杨蕾', '杨新忠', '杨妍', '虞琼洁', '战国栋', '张培源', '赵建东', '赵之昱', '周博', '周峰', 
          '朱日能', '朱亭赞', '朱占忠', '左佐'
        ],
        organization: ['字魔营','869设计学校','佐字社™️','loyoType'],
      },
      // time = new Date().getTime(),
      date_off = parseInt(new Date('2023-09-16').getTime()/86400000-19550),
      progress = {
        date_off,
        step: 'shortlist',
        line: '',
        items: [
          {i:1, date:'7月12日', date_off:0, step:'shortlist', name:'入围榜单'},
          {i:2, date:'7月26日', date_off:14, step:'excellent', name:'优秀榜单'},
          {i:3, date:'9月4日', date_off:54, step:'final', name:'决赛榜单'},
        ]
      };
    
    progress.line = 16.66+33.33*(date_off>=14?(1+(date_off-14)/40):(0.05+date_off/14*0.95));
    // console.log(progress);
    return {
      ending: false,
      picker: {
        key: '',
        items: [],
        show: false,
      },
      award: {
        show: false,
        pic: '',
      },
      consult: [
        {name:'王 敏', key:'wangmin', desc:'中央美术学院学术委员会副主任<br/>长江学者特聘教授/博导<br/>国际平面设计联盟（AGI）会员'},
        {name:'王粤飞', key:'wagnyuefei', desc:'王粤飞设计有限公司创始人<br/>纽约艺术指导俱乐部（ADC）会员<br/>国际平面设计师联盟（AGI）会员'},
        {name:'陈 楠', key:'chennan', desc:'清华大学美术学院教授/博导<br/>中国美术家协会平面设计艺委会副秘书长<br/>中国古文字艺术研究中心常务副主任'},
        {name:'马忆原', key:'mayiyuan', desc:'汉仪“字体之星”设计大赛创立人<br/>北京汉仪创新科技股份有限公司副总经理、董事<br/>中国中文信息学会汉字字形信息专委会 副主任委员<br/>中国出版协会文字规范化工委 副主任'},
      ],
      judges4zhongwen: [
        {name:'毕学锋', key:'bixuefeng', desc:'中国美术学院教授<br/>国际平面设计联盟（AGI）会员<br/>深圳平面设计协会学术委员'},
        {name:'陈 嵘', key:'chenrong', desc:'上海视觉艺术学院教授<br/>设计学院副院长'},
        {name:'郭晓晔', key:'guoxiaoye', desc:'北京服装学院 艺术设计学院教授<br/>视觉传达设计专业负责人<br/>汉仪妙草、AA榜黑主创设计师'},
        {name:'李少波', key:'lishaobo', desc:'湖南师范大学美术学院教授<br/>湖南省汉字文化与艺术研究基地负责人<br/>中国文字设计与研究中心学术委员'},
        {name:'谭智恒', key:'tanzhiheng', desc:'香港知专设计学院副院长暨副学术总监<br/>上海大学上海美术学院特聘研究员'},
        {name:'王潇娴', key:'wangxiaoxian', desc:'南京艺术学院副教授/硕导<br/>“维米设计”创始人/字愈品牌主理人<br/>汉仪金陵刻经、汉仪金陵美宋主创设计师'},
        {name:'西塚凉子<br/>Ryoko Nishizuka', key:'ryoko', desc:'Adobe高级设计师'},
        {name:'朱志伟', key:'zhuzhiwei', desc:'中国著名字体设计师'},
        {name:'战国栋', key:'zhanguodong', desc:'大连民族大学教师<br/>国际平面设计联盟（AGI）会员<br/>深圳平面设计协会（SGDA）会员<br/>南京平面设计师联盟会员'},
      ],
      judges4duowenzhong: [
        {name:'刘 钊', key:'liuzhao', desc:'中央美术学院副教授<br/>国际文字设计协会(ATypl)理事'},
        {name:'Titus Nemeth', key:'titus', desc:'博士<br/>奥地利文字设计协会会员<br/>奥地利设计协会会员'},
        {name:'西塚凉子<br/>Ryoko Nishizuka', key:'ryoko', desc:'Adobe高级设计师'},
        {name:'柳良姬<br/>Yanghee Ryu', key:'yanghee', desc:'字体设计师<br/>英国雷丁大学硕士'},
        {name:'张 暄', key:'zhangxuan', desc:'汉仪字库高级字体设计师<br/>西文字体设计负责人<br/>高级定制项目负责人'},
      ],
      consult1: [
        {name:'程训昌', key:'chengxunchang', desc:'雷丁大学字体设计博士/访问研究员<br/>字体设计师'},
        {name:'刘 庆', key:'liuqing', desc:'字体排印研究者<br/>The Type 执行编辑<br/>《字谈字畅》制作人兼主播<br/>纽约 TDC 顾问理事<br/>国际字体协会（ATypI）会员'},
      ],
      progress,
      timer: ['', ''],
      table,
      bottom,
      showFinal: false,
    }
  },
  mounted(){
    let time = 0;
    if(location.href.match(/time=([^&]*)/)){
      time = +RegExp.$1;
    }
    let timer = ()=>{
      let t = time||parseInt(new Date().getTime()/60000),
        n = function(n){
          return '<i>'+(n<10?'0':'')+parseInt(n)+'</i>';
        },
        f = function(t){
          return n(t/1440)+n((t%1440)/60)+n((t%1440)%60);
        },
        t1 = f(28172520-t), //new Date('2023/07/26 14:00').getTime()/60000
        t2 = f(28230240-t); //new Date('2023/09/04 16:00').getTime()/60000

      let progress = this.progress;
      //决赛
      if(t>=28230240){  //new Date('2023/09/04 16:00').getTime()/60000
      // if(t>=28165920){  //new Date('2023/7/25').getTime()/60000  test
        if(progress.step!='final'){
          progress.step = 'final';
          this.bottom.txt = 'open';
        }
        this.showFinal = true;
        if(_.isEmpty(this.table.final)){
          this.table_init('final');
        }
      } 
      else{
        //优秀
        if(t>=28172520){  //new Date('2023/7/26').getTime()/60000
        // if(t>=28170240){  //new Date('2023/7/25').getTime()/60000
          if(progress.step!='excellent'){
            progress.step = 'excellent';
          }
        }
        if(_.isEmpty(this.table.shortlist)){
          this.table_init('shortlist');
        }
      }
      this.timer = [t1, t2];
      this.bottom.timer = t2;
      // console.log(progress);
      // setTimeout(timer, 20*1000);
    };
    timer();
    
    const wx = require('weixin-js-sdk');
    this.$axios.post('https://www.hanyi.com.cn/weixin/php/signature', {url: location.href}).then(data=>{
      // console.log(data);
      wx.config({
        // debug: true,
        appId: data.appId,
        timestamp: data.timestamp,
        nonceStr: data.nonceStr,
        signature: data.signature,
        jsApiList: ["updateTimelineShareData", "updateAppMessageShareData"]
      });
      wx.ready(function() {
        let title = {
            'shortlist':'入围名单',
            'excellent':'优秀奖项公布',
            'final':'颁奖典礼',
          }['final']+'｜汉仪第六届字体之星设计大赛',
          desc = '恭喜入选！',
          link = location.href,
          //imgUrl = "https://www.hanyi.com.cn/weixin/h5/award2020/logo.png";
          imgUrl = "https://fontstar.oss-cn-beijing.aliyuncs.com/award2025/head/title_logo.jpg";
        //分享到朋友圈
        wx.updateTimelineShareData({
          title, link, imgUrl,
          success: function () {
          }
        });
        //分享给朋友
        wx.updateAppMessageShareData({
          title, link, imgUrl, desc,
          success: function() {
            // _czc && _czc.push(["_trackEvent", "送给未来的自己", "分享给好友"])
          },
        });
      })
    });
    this.table_init('excellent');
  },
  methods: {
    table_init(name){
      this.$axios.get(`https://fontstar.oss-cn-beijing.aliyuncs.com/award2025/json/${name}.json?t=${_.now()}`).then(data=>{
        this.table[name] = (data);
      });
    },
    generate_pick(data){
      if(data.type=='final'){
        data.items = _.chain(data.items).groupBy('prize').map((group, key)=>{
          return {
            works:{
              '1': '一等奖',
              '2': '二等奖',
              '3': '三等奖',
              'j': '评委奖',
            }[key],
            children: group,
          }
        }).value();
      }
      this.picker = _.extend({
        show: true,
        generate: null,
      }, data);
    },
    generate_confirm(item, index){
      if(index.length){
        item = this.picker.items[index[0]].children[index[1]];
      }
      // console.log('generate_confirm', item, arguments);
      let key = this.picker.key,
        canvas = this.$refs['canvas'+(item.prize?'-final':(key.match('excellent')?'-excellent':''))],
        ctx = canvas.getContext('2d'),
        img = new Image();
      
      img.onload = ()=>{
        // 统一使用751x1332尺寸绘制
        ctx.drawImage(img, 0, 0, 751, 1332);
        ctx.fillStyle = {
          'shortlist': '#E3CA96',
          'excellent': '#E3CA96',
          'final': '#E3CA96',
        }[key.split('/')[0]];
        
        let x = 300, y = 978, r = 90, font_base = "36px Helvetica";
        if(key.match('excellent|final')){
          x = 30, y = 720, r = 120;
          font_base = "28px Helvetica";
        }
        ctx.font = font_base;
        
        // 绘制作品名称
        let works = item.works,
          a = 0;
        if(works.length>20){
          ctx.font = "18px Helvetica";
          a = -7;
        }
        else if(works.length>10){
          ctx.font = "24px Helvetica";
          a = -4;
        }
        ctx.fillText(`${item.works}`, x, y+r+a);
        
        // 绘制作者姓名
        let author = item.author;
        if(author.length>10){
          ctx.font = "24px Helvetica";
          author = author.split(/，|、/);
          let mid = parseInt(author.length/2);
          ctx.fillText(author.slice(0,mid).join('、'), x, y+r*1.6);
          ctx.fillText(author.slice(mid).join('、'), x, y+r*2);
        }else{
          ctx.font = font_base;
          ctx.fillText(author, x, y+r*2);
        }
        
        this.award = {
          show: true,
          pic: canvas.toDataURL('image/png'),
        }
        this.$toast({
          message: '长按保存图片，分享朋友圈',
          position: 'top',
        });
      };
      // 根据组别确定模板文件名
      let templatePath = '';
      if(key.match('excellent')){
        // excellent类型：根据tab.selected确定模板
        const tabKey = key.split('/')[1]; // 获取 cn-stu, cn-pro, en 等
        let templateName = tabKey;
        
        // 如果是多文种(en)，需要根据group字段确定具体文种
        if(tabKey === 'en' && item.group){
          const groupMap = {
            '拉丁文字母': 'mmdc-L',
            '阿拉伯': 'mmdc-a', 
            '韩字': 'mmdc-h',
            '日文假名': 'mmdc-k'
          };
          templateName = groupMap[item.group] || 'mmdc-L';
        }
        
        templatePath = `excellent/${templateName}`;
      } else if(key.match('shortlist')){
        // shortlist类型
        const tabKey = key.split('/')[1];
        templatePath = `shortlist/${tabKey}`;
      } else if(item.prize){
        // final类型（有奖项）
        templatePath = `final/${key.split('/')[1]}-${item.prize}`;
      }
      
      console.log(key, item, `@/assets/award/${templatePath}.png`);
      img.src = require(`@/assets/award/${templatePath}.png`);
      this.picker.show = false;
      // console.log('confirm', item, this.picker.key, canvas);
    },
  }
}
</script>

<style lang="less">
  *{
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
  body{
    font-family: Helvetica,PingFang SC,Microsoft YaHei,Arial,sans-serif;
    background: #000000;
    color: #333;
    font-size: 14px;
  }
  a{
    cursor: pointer;
  }
  h6{
    font-weight: normal;
  }
  img{
    width: 100%;
  }
  ::-webkit-scrollbar{
    display: none;
  }

  .clear:after,.clear:before {
    content: " ";
    display: table
  }
  .clear:after {
    clear: both
  }

  body{
    background-size: 100% auto;
  }

  #app{
    text-align: center;
    /* padding:  0 0 112px; */
    padding:  0 0 32px;
  }

  section.head{
    margin: 0 0 28px;
    .timeline{
      width: 100%;
      display: block;
      margin: 0 auto;
    }
  }
  
  .middle-banner{
    margin: 16px;
  }
  
  .time .sub{
    white-space: nowrap;
    margin: 4px 3px;
  }
  .time .sub span{
    width: 62px;
    font-size: 12px;
    letter-spacing: 0.1em;
    color: #9B9B9B;
  }

  .judges{
    margin: 4px 16px;
    padding: 6px 20px 6px 24px;
    background: #000000;
    border-radius: 4px;
    div{
      position: relative; 
      padding-left: 116px;
      margin: 24px 0;
      height: 100px;
      text-align: left;
    }
    img{
      width: 100px;
      position: absolute;
      left: 0;
      top: 0;
    }
    h6{
      line-height: 1;
      font-weight: 600;
      font-size: 14px;
      margin: 0 0 6px;
      color: #FFFFFF;
    }
    p{
      font-size: 12px;
      line-height: 17px;
      color: #FFFFFF;
      margin: 0;
    }
  }

  .logo-wall{
    margin: 0 16px 32px;
    padding: 24px;
    background: #000000;
    border-radius: 4px;
  }

  .subscribe{
    margin: 0 16px;
    background: #000000;
    border-radius: 4px;
    padding: 16px;
    height: 96px;
    color: #fff;
  }
  .subscribe>*{
    float: left;
    text-align: left;
  }
  .subscribe .qr{
    width: 68px;
    float: right;
    margin-top: -2px;
  }
  .subscribe .logo{
    width: 64px;
    margin-right: 8px;
  }
  .subscribe h6{
    font-size: 14px;
    margin: 0 0 8px;
  }
  .subscribe p{
    font-size: 12px;
    line-height: 18px;
    opacity: 0.85;
  }

  .bottom{
    position: fixed;
    z-index: 1001;
    left: 0;
    bottom: 0;
    width: 100%;
    padding: 8px 16px;
    height: 68px;
    background: #fff;
    text-align: left;
    &:before{
      position: absolute;
      top: -4px;
      left: 0;
      content: ' ';
      display: block;
      height: 4px;
      width: 100%;
      background: radial-gradient(94.58% 333.43% at 1.33% 50%, #FFFAE9 0%, rgba(255, 249, 232, 0) 100%);
    }
    *{
      display: inline-block;
      width: auto;
      vertical-align: top;
    }
    .txt{
      height: 32px;
      margin: 4px 0 0;
      &.award{
        height: 18px;
        margin: 10px 0 0;
      }
    }
    .btn{
      float: right;
      img{
        height: 40px;
      }
    }
    .time{
      width: 192px;
      float: right;
      position: relative;
      .sub{
        text-align: left;
        margin: 4px 0;
        span{
          width: 66px;
        }
      }
      .number{
        position: absolute;
        top: 0;
        left: 8px;
        font-weight: bold;
        font-size: 20px;
        color: #fff;
        line-height: 33px;
        letter-spacing: 16px;
        white-space: nowrap;
        i{
          margin-right: 12px;
          display: inline-block;
          width: 55px;
          text-align: center;
        }
      }
    }
  }

  section{
    &>.title{
      width: 165px;
    }
    &.billboard{
      &>.title{
        margin: 0 0 10px 24px;
      }
    }
    &.judge{
      margin: 0 auto 32px;
      .title{
        height: 40px;
        margin: 32px 16px 24px 15px;
        display: block;
      }
    }
  }
  
  .van-picker__toolbar{
    button{
      color: #D8543D;
    }
    &>*{
      font-size: 17px;
      line-height: 44px;
    }
  }

  .award.van-popup{
    max-width: 80%;
    width: 750px;
    background: transparent;
    img{
      width: 100%;
    }
  }
  .van-toast--top{
    top: 5%;
  }

  
@media (min-width: 987px) {
  #app{
    padding: 0 0 184px;
  }
  section.head{
    max-width: 100%;
    background: none;
    padding: 0;
    .timeline{
      width: 1220px;
    }
    .banner{
      margin: 0 0 48px;
      position: relative;
      img{
        height: 505px;
        width: auto;
        max-width: 100%;
      }
    }
  }
  
  .middle-banner{
    width: 955px;
    margin: 16px auto;
  }
  
  .judges{
    margin: 4px 0;
    padding: 40px 23px 15px;
    div{
      width: 255px;
      text-align: center;
      float: left;
      padding: 0;
      margin: 0 24px 40px;
      height: 344px;
      &:nth-child(1),
      &:nth-child(2),
      &:nth-child(3){
        height: 368px;
      }
    }
    img{
      position: static;
      width: 100%;
    }
    h6{
      font-size: 16px;
      margin: 16px 0 8px;
    }
    p{
      text-align: center;
      line-height: 18px;
    }
    &.consult-row{
      display: flex;
      justify-content: space-between;
      padding: 16px;
      div{
        width: 23%;
        padding-left: 0;
        text-align: center;
        margin: 0;
        height: auto;
      }
      img{
        position: static;
        width: 100%;
        margin-bottom: 8px;
      }
      h6{
        font-size: 12px;
        margin-bottom: 4px;
      }
      p{
        font-size: 10px;
        line-height: 14px;
      }
    }
  }
  .logo-wall{
    width: 955px;
    margin: 0 auto 64px;
    padding: 40px 115px 60px;
  }
  .subscribe{
    margin: 0 auto;
    background: none;
    padding: 148px 0 0;
    position: relative;
    &>*{
      float: none;
      text-align: center;
    }
    h6,.logo{
      display: none;
    }
    p{
      font-size: 16px;
      line-height: 28px;
    }
    .qr{
      float: none;
      position: absolute;
      top: 0;
      left: 50%;
      margin: 0 0 0 -65px;
      width: 136px;
    }
  }
  .bottom{
    text-align: center;
    height: 64px;
    .txt{
      height: 24px;
      margin: 11px 32px 0 0;
    }
    .time,.btn{
      float: none;
    }
    .btn{
      img{
        margin: -8px 0;
        height: 64px;
      }
    }
  }
  section{
    max-width: 987px;
    margin-left: auto;
    margin-right: auto;
    padding: 0 16px;
    &.judge{
      .title{
        height: 80px;
        margin: 56px 0 48px 39px;
        display: block;
      }
    }
  }
}
</style>
